import React, { PureComponent, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import i18n from 'cityads-v3/i18n'
import config from 'cityads-v3/config'

import Recaptcha from 'react-recaptcha'
import AutocompleteSelect from 'cityads-v3/components/AutocompleteSelect/AutocompleteSelect'
import EmptyResults from 'cityads-v3/components/EmptyResults/EmptyResults'
import TextField from 'cityads-v3/components/TextField/TextField'
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton'

import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'

import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'

import { sendFeedback, feedbackRefresh, getFeedbackSubjects, clearInputError } from 'cityads-v3/actions/feedback'

import {
  getRegions
} from 'cityads-v3/actions/offers'

import classes from './ContactForm.scss'

export const MAX_EMAIL_LENGTH = 640
export const SUBJECT_ID_VACANCY = 1
export const SUBJECT_ID_NO_VACANCY = 2

@withRouter
@connect(
  state => ({
    isSendingFeedback: state.feedback.isSending,
    contactSubjects: state.feedback.subjects,
    contactCities: state.feedback.cities,
    isFeedbackSended: state.feedback.isFeedbackSended,
    isSubjectsLoaded: state.feedback.isSubjectsLoaded,
    isFeedbackError: state.feedback.isFeedbackError,

    feedbackErrors: state.feedback.feedbackErrors,
    feedbackErrorMessage: state.feedback.feedbackErrorMessage,

    language: state.language.language,

    regionsById: state.offers.regionsById,
    isLoadedRegions: state.offers.isLoadedRegions,
  })
)
@withTranslation(['main', 'About'], { i18n, wait: !!window })
export default class ContactForm extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    language: PropTypes.string,
    showAttach: PropTypes.bool,
    isSendingFeedback: PropTypes.bool,
    isFeedbackSended: PropTypes.bool,
    isSubjectsLoaded: PropTypes.bool,
    contactSubjects: PropTypes.arrayOf(PropTypes.object),
    contactCities: PropTypes.arrayOf(PropTypes.object),
    textProps: PropTypes.object,
    selectProps: PropTypes.object,
    buttonProps: PropTypes.object,
    f: PropTypes.func,
    regionsById: PropTypes.object,
    isLoadedRegions: PropTypes.bool,
    isFeedbackError: PropTypes.bool,
    feedbackErrors: PropTypes.object,
    feedbackErrorMessage: PropTypes.string,
  }

  state = {
    from: '',
    subject: this.props.defaultSubject || SUBJECT_ID_NO_VACANCY,
    message: '',
    country: '',
    errors: {},

    isCaptchaLoaded: false,
  }

  recaptchaInstance = null;

  componentDidMount() {
    const { dispatch } = this.props

    if (!this.props.isLoadedRegions) {
      dispatch(getRegions())
    }

    if (!this.props.isSubjectsLoaded) {
      dispatch(getFeedbackSubjects())
    }

  }

  componentDidUpdate(prevProps) {
    const { dispatch, language, isSendingFeedback } = this.props

    if (prevProps.language !== language) {
      dispatch(getRegions())
      dispatch(getFeedbackSubjects())
    }

    if (prevProps.isSendingFeedback && !isSendingFeedback) {
      this.recaptchaInstance?.reset()
    }
  }

  verifyFormData() {
    let errors = {}
    let hasErrors = false

    if (!this.state.from) {
      errors.from = this.props.t('forms.errorFieldNoEmpty')
      hasErrors = true
    }

    this.setState({ errors })
    return !hasErrors
  }

  onInputChange = evt => {
    const { feedbackErrors, dispatch } = this.props
    const fieldName = evt.target.name
    this.setState({ [fieldName]: evt.target.value })

    if (!!feedbackErrors[fieldName]) {
      dispatch(clearInputError(fieldName))
    }
  }

  onCountryChange = (country) => {
    const { feedbackErrors, dispatch } = this.props

    this.setState({ country: (country && country.value) })

    if (!!feedbackErrors['country']) {
      dispatch(clearInputError('country'))
    }
  }

  onSelectChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onFileChange = evt => {
    if (!evt.target.files || !evt.target.files.length) {
      return
    }
    this.attach_file = evt.target.files[0]
    this.forceUpdate()
  }

  onFormSubmit = (evt) => {
    evt.preventDefault()

    if (!this.verifyFormData()) {
      return
    }

    if (config.RECAPTCHA_IGNORE) {
      this.checkCaptcha()
    } else {
      this.recaptchaInstance.execute()
    }
  }

  onCaptchaLoaded = () => {
    this.setState({ isCaptchaLoaded: true })
  }

  checkCaptcha = token => {
    this.props.dispatch(sendFeedback({
      from: this.state.from,
      subject: this.state.subject,
      message: this.state.message,
      country: this.state.country,
      attachment: this.attach_file,
      'g-recaptcha-response': token,
    }))
  }

  refreshForm = () => {
    this.props.dispatch(feedbackRefresh())
  }

  render() {
    const {
      className,
      showAttach, isSendingFeedback, isFeedbackSended, contactSubjects,
      textProps, selectProps, buttonProps, t, match,
      feedbackErrors, feedbackErrorMessage
    } = this.props
    const { from, subject, message, errors, isCaptchaLoaded } = this.state

    const countries = Object.keys(this.props.regionsById)
      .map(key => ({
        ...this.props.regionsById[key],
        label: this.props.regionsById[key].name
      }))
      // Мы получаем дерево с глубиной до стран. У стран нет детей, у более высоких уровней (Весь мир, Европа, СНГ) - есть. Мы пропускаем эти уровни.
      .filter(region => !region.items)

    const isSubPageLoaded = match.params.sub

    if (isFeedbackSended) {
      return (
        <div className={className}>
          <EmptyResults
            icon="done"
            emptyText={t('contactFormCard.sended')}
          />
        </div>
      )
    }

    return (
      <form className={className} onSubmit={this.onFormSubmit}>
        <FormControl variant="standard" margin="normal" fullWidth={true}>
          <TextField
            name="from"
            value={from}
            onChange={this.onInputChange}
            label={t('contactFormCard.email')}
            error={!!errors?.from || !!feedbackErrors?.from}
            helperText={errors?.from ?? feedbackErrors?.from}
            fullWidth={true}
            variant="standard"
            {...textProps}
          />
        </FormControl>

        <FormControl variant="standard" margin="normal" fullWidth={true}>
          <InputLabel htmlFor="subject">{t('contactFormCard.subject')}</InputLabel>
          <Select
            inputProps = {{
              name: 'subject',
              id: 'subject',
            }}
            value={contactSubjects.length ? subject : ''}
            onChange={this.onSelectChange}
            error={!!errors?.subject}
            {...selectProps}
          >
            {contactSubjects.map(subj =>
              <MenuItem key={subj.id} value={subj.id}>{subj.title}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl variant="standard" margin="dense" fullWidth={true}>
          <AutocompleteSelect
            suggestions={countries}
            error={!!errors?.country || !!feedbackErrors?.country}
            helperText={feedbackErrors?.country}
            label={t('contactFormCard.country')}
            onChange={this.onCountryChange}
            fullWidth={true}
            id={'country'}
          />
        </FormControl>

        <TextField
          name="message"
          value={message}
          onChange={this.onInputChange}
          label={t('contactFormCard.text')}
          margin="normal"
          error={!!errors?.message || !!feedbackErrors?.message}
          helperText={errors?.message || feedbackErrors?.message}
          multiline={true}
          minRows={1}
          maxRows={4}
          maxLength={MAX_EMAIL_LENGTH}
          fullWidth={true}
          variant="standard"
          {...textProps}
        />

        {showAttach && (
          <>
            <input
              className={classes.contactCardAttachFile}
              type="file"
              ref="attach_file"
              onChange={evt => this.onFileChange(evt)}
            />
            <Button onClick={() => this.refs.attach_file.click()} startIcon={<AttachFileOutlinedIcon />} size="small">
              {this.attach_file ? this.attach_file.name : t('About:vacancy.attach_file')}
            </Button>
          </>
        )}

        {feedbackErrorMessage ? <Typography color="error">{feedbackErrorMessage?.message ?? feedbackErrorMessage}</Typography> : null}

        <div className={classes.buttonContainer}>
          {!isSubPageLoaded && (
            <RenderAfterRecaptchaLoaded>
              <Recaptcha
                ref={ri => this.recaptchaInstance = ri}
                sitekey={config.RECAPTCHA_KEY}
                size="invisible"
                onloadCallback={this.onCaptchaLoaded}
                verifyCallback={this.checkCaptcha}
              />
            </RenderAfterRecaptchaLoaded>
          )}

          <WaitingButton
            type="submit"
            variant="contained"
            color="primary"
            waiting={isSendingFeedback || !isCaptchaLoaded}
            fullWidth={true}
            {...buttonProps}
          >
            {t('forms.submit')}
          </WaitingButton>
        </div>
      </form>
    )
  }
}

function RenderAfterRecaptchaLoaded({ children }) {
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(typeof window?.grecaptcha?.render === 'function')

  if (recaptchaLoaded) {
    return children
  }

  window?.grecaptcha?.ready?.(() => setRecaptchaLoaded(true))

  return null
}
